import AbstractProvider from "@uxuycom/web3-tg-sdk/dist/types/src/provider/AbstractProvider";
import { CreateOrder } from "~/types";

interface ConnectionWrapper {
    provider: AbstractProvider;
    address: string | null | undefined;
    addressType: number;
    chainId: string;
    alliance: PROVIDER_ALLIANCE;
    isConnected(): boolean;
    connect(): Promise<void>;
    // 获取用户的钱包地址，未连接钱包时，自动唤起钱包
    getAddress(): Promise<string | null | undefined>;
    // 静默获取用户的钱包地址，未连接钱包时，返回 null
    getAddressSilently(): Promise<string | null | undefined>;
    sendTransaction(chain_id: string, tradeOrder: CreateOrder): Promise<any>;
    waitForTransaction(
        hash: string,
        timeout?: number,
        count?: number
    ): Promise<any>;
    disconnect(): Promise<void>;
}

// TODO: EVM = "eth"  TRON = "trx"  bak
export enum PROVIDER_ALLIANCE {
    LIGHTNING = "lightning",
    TRON = "tron",
    EVM = "evm",
    TON = "ton",
    SOL = "sol",
    COSMOS = "cosmos",
    SUI = "sui",
}

export enum CHAIN_IDS {
    ALL = -1,
    BNBCHAIN = 56,
    LIGHTNING = 2652501241,

    BASE = 8453,
    ZKLINK = 810180,
    POLYGON = 137,
    ARB = 42161,
    AVALANCHEC = 43114,
    ETH = 1,
    FANTOM = 250,
    OPTIMISM = 10,
    LINEA = 59144,
    ZKSYNC = 324,
    CORE = 1116,
    BITLAYER = 200901,
    MOONCHAIN = 1868,
    MERLIN = 4200,

    TRON = 728126428,
    TON = 239,

    SOLANA = 6000001,

    SUI = -1000000,
}

export default ConnectionWrapper;
